
import { IBaseComponentUITag } from "@root/components/interfaces";
import { PropInnateSync } from "@root/core/vue-props";
import { Prop, Component, Emit } from "vue-property-decorator";
import { BaseTableCore } from "./base-table-core";
import { defaultBodyData, ITableBodyData } from "./core";

@Component
export default class TableBody extends BaseTableCore {
    @Prop({ type: Object, required: false })
    declare data: ITableBodyData;
    get mergedData() {
        return {
            ...defaultBodyData,
            ...this.data,
        };
    }

    /// events
    @Emit("reload")
    doReload() {
        return true;
    }

    @PropInnateSync("selected", { type: Object, required: false, default: null })
    innateSelected!: any;

    @Prop({ type: Object, required: false })
    uiTag?: IBaseComponentUITag;

    @Emit("select")
    doSelect(data: any) {
        if (this.isDataEqual(data, this.innateSelected)) data = null;
        this.innateSelected = data;
        return this.innateSelected;
    }

    /// private helpers
    isSelected(data: any) {
        return this.isDataEqual(data, this.innateSelected);
    }

    bindAttrs(idxData: number, idxMeta: number) {
        return {
            ...this.bindCellProperties("TableBodyCell", idxData, idxMeta, this.uiTag)
                .props,
        };
    }
}
